export const STAFF_SEARCH_FIELDS = [
  {
    label: 'label.BILLING_ID',
    value: 'billingid'
  },
  {
    label: 'label.DOMAIN',
    value: 'query'
  }
];
